(function () {
  const roots = document.querySelectorAll('.gut');

  function initGallery(gallery) {
    const slides = Array.from(gallery.querySelectorAll('[data-gut-slide]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-gut-thumb]'));
    const prev = gallery.querySelector('[data-gut-prev]');
    const next = gallery.querySelector('[data-gut-next]');
    let index = 0;

    function show(nextIndex) {
      index = Math.min(Math.max(nextIndex, 0), slides.length - 1);
      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === index);
        slide.classList.toggle('is-before', slideIndex < index);
      });
      thumbs.forEach((thumb, thumbIndex) => {
        thumb.classList.toggle('is-active', thumbIndex === index);
        thumb.setAttribute('aria-current', thumbIndex === index ? 'true' : 'false');
      });
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
    }

    function go(nextIndex) {
      show(nextIndex);
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => go(Number(thumb.dataset.gutThumb)));
    });
    prev?.addEventListener('click', () => go(index - 1));
    next?.addEventListener('click', () => go(index + 1));
    show(index);
  }

  function initTestimonials(root) {
    const carousel = root.querySelector('[data-gut-testimonial-carousel]');
    if (!carousel) return;
    const slides = Array.from(carousel.querySelectorAll('[data-gut-testimonial-slide]'));
    const prev = carousel.querySelector('[data-gut-testimonial-prev]');
    const next = carousel.querySelector('[data-gut-testimonial-next]');
    let index = slides.findIndex((slide) => slide.classList.contains('is-active'));
    if (index < 0) index = 0;

    function show(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === index);
        slide.classList.toggle('is-before', slideIndex < index);
      });
    }

    prev?.addEventListener('click', () => show(index - 1));
    next?.addEventListener('click', () => show(index + 1));

    let timer = window.setInterval(() => show(index + 1), 4800);
    carousel.addEventListener('mouseenter', () => window.clearInterval(timer));
    carousel.addEventListener('mouseleave', () => {
      timer = window.setInterval(() => show(index + 1), 4800);
    });
    show(index);
  }

  function initLabel(root) {
    const dialog = root.querySelector('[data-gut-label]');
    const open = root.querySelector('[data-gut-open-label]');
    const close = root.querySelector('[data-gut-close-label]');
    if (!dialog || !open || !close) return;
    open.addEventListener('click', () => {
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    });
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  }

  function initBatch(root) {
    const dateEl = root.querySelector('[data-gut-batch-date]');
    if (!dateEl) return;
    const date = new Date();
    date.setDate(date.getDate() + 2);
    const day = date.getDate();
    const suffix = day % 10 === 1 && day !== 11 ? 'st' : day % 10 === 2 && day !== 12 ? 'nd' : day % 10 === 3 && day !== 13 ? 'rd' : 'th';
    dateEl.textContent = `${date.toLocaleDateString('en-US', { month: 'long' })} ${day}${suffix}`;
  }

  function initCountdown(root) {
    const countdown = root.querySelector('[data-gut-countdown]');
    if (!countdown) return;
    const hoursEl = countdown.querySelector('[data-gut-countdown-hours]');
    const minutesEl = countdown.querySelector('[data-gut-countdown-minutes]');
    const secondsEl = countdown.querySelector('[data-gut-countdown-seconds]');
    const expiredEl = root.querySelector('[data-gut-countdown-expired]');
    if (!hoursEl || !minutesEl || !secondsEl) return;

    const deadline = new Date(countdown.dataset.gutCountdownDeadline || '2026-06-20T23:59:59');
    const pad = (value) => String(value).padStart(2, '0');

    function render() {
      const remaining = deadline.getTime() - Date.now();
      if (remaining <= 0) {
        countdown.hidden = true;
        if (expiredEl) expiredEl.hidden = false;
        return;
      }
      const hours = Math.floor((remaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((remaining % (1000 * 60)) / 1000);
      hoursEl.textContent = String(hours);
      minutesEl.textContent = pad(minutes);
      secondsEl.textContent = pad(seconds);
      window.setTimeout(render, 1000);
    }

    render();
  }

  function updateBuybox(box) {
    const mode = box.querySelector('[data-gut-purchase-type]:checked')?.value || 'subscription';
    const options = box.querySelectorAll('.gut-option');
    options.forEach((option) => {
      const input = option.querySelector('[data-gut-variant]');
      const save = mode === 'subscription' ? input.dataset.subSave : input.dataset.oneSave;
      const price = mode === 'subscription' ? input.dataset.subPrice : input.dataset.onePrice;
      const copy = option.querySelector('[data-gut-bottles-copy]');
      const priceEl = option.querySelector('[data-gut-price]');
      const bottles = option.querySelector('strong')?.textContent?.match(/\d/)?.[0] || '1';
      copy.textContent = `${bottles} bottle${bottles === '1' ? '' : 's'} total | Save ${save}`;
      priceEl.textContent = price;
      option.classList.toggle('is-active', input.checked);
    });
    box.classList.toggle('is-onetime', mode === 'onetime');
  }

  async function addToCart(box, button) {
    const mode = box.querySelector('[data-gut-purchase-type]:checked')?.value || 'subscription';
    const selected = box.querySelector('[data-gut-variant]:checked');
    const message = box.querySelector('[data-gut-cart-message]');
    if (!selected) return;

    const item = {
      id: Number(selected.dataset.variantId),
      quantity: 1,
    };
    if (mode === 'subscription' && selected.dataset.sellingPlan) {
      item.selling_plan = Number(selected.dataset.sellingPlan);
    }

    button.disabled = true;
    button.textContent = 'Adding...';
    if (message) message.textContent = '';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ items: [item] }),
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.description || data.message || 'Unable to add this bundle.');
      }
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
      window.Upcart?.refresh?.();
      button.textContent = 'Added to Cart';
      if (message) {
        message.innerHTML = 'Added to cart. <a href="/cart">View cart</a> or continue shopping.';
      }
    } catch (error) {
      button.textContent = 'Add to Cart';
      if (message) message.textContent = error.message;
    } finally {
      button.disabled = false;
    }
  }

  function initBuybox(box) {
    box.addEventListener('change', (event) => {
      if (event.target.matches('[data-gut-purchase-type], [data-gut-variant]')) {
        updateBuybox(box);
      }
    });
    box.querySelector('[data-gut-add-to-cart]')?.addEventListener('click', (event) => {
      addToCart(box, event.currentTarget);
    });
    updateBuybox(box);
  }

  roots.forEach((root) => {
    root.querySelectorAll('[data-gut-gallery]').forEach(initGallery);
    root.querySelectorAll('[data-gut-buybox]').forEach(initBuybox);
    initTestimonials(root);
    initLabel(root);
    initBatch(root);
    initCountdown(root);
  });
})();
